import React, {useRef} from 'react';
import MyTicketsButton from "@User/components/MyTicketsButton";
import useIsCheckOrder from "@CheckOrder/hooks/useIsCheckOrder";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import Logo from "./Logo";
import Navbar from "@Header/components/TopBar/Navbar";
import Row from "@Containers/components/Row";
import useIsDesktop from "@Hooks/selector/useIsDesktop";

function TopBar() {
    const topBarRef = useRef<HTMLDivElement>(null)
    const isCheckOrder = useIsCheckOrder()
    const {stripeClientSecret} = useAppSelector((state) => state?.checkOrder)
    const isDesktop = useIsDesktop()

    return (
        <header className="gb--header gb--row gb--row-middle gb--row-justify">
            <Logo/>
            {!stripeClientSecret && (
                <Row scrollRef={topBarRef} center justify className="gb--header_content-wrapper">
                    {!isCheckOrder && (
                        <>
                            {!isDesktop && (
                                <MyTicketsButton/>
                            )}
                            <Navbar topBarRef={topBarRef}/>
                            {isDesktop && (
                                <MyTicketsButton/>
                            )}
                        </>
                    )}
                </Row>
            )}
        </header>
    );
}

export default TopBar
